import React from "react";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

function ShowWeeklySummaryCardsButton(props) {
  const active = !!props.showWeeklySummaryCards;
  return (
    <MenuItem
      onClick={() => {
        props.toggleShowWeeklySummaryCards();
        props.onMenuItemClick?.();
      }}
      sx={{ py: 1.25 }}
    >
      <ListItemIcon sx={{ color: active ? "#6d28d9" : undefined }}>
        <SpaceDashboardOutlinedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          fontSize: 14,
          color: active ? "#6d28d9" : undefined,
          fontWeight: active ? 600 : 400,
        }}
      >
        Show summary cards
      </ListItemText>
      {active && <CheckIcon sx={{ color: "#6d28d9", fontSize: 18 }} />}
    </MenuItem>
  );
}

export default ShowWeeklySummaryCardsButton;
